<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <!-- BOTÃO SALVAR -->
            <div class="header-buttons">
                <button
                    v-if="permissaoCadastrar"
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <!-- CAMPO BLINDAGEM -->
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <v-input
                        :id="generateId(1)"
                        ref="blindagemInput"
                        v-model="empresa.blindagem"
                        placeholder="placeholder-preencha"
                        title="blindagem"
                        tooltipLabel="informacao-empresa-blindagem"
                        tooltipPosition="is-right"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import Message from '@/models/Message';

export default {
    data() {
        return {
            empresaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('EMPRESA'),
            service: new EmpresaService(this.$http, this.$router),
            msgs: [],

            isLoading: false,
            isSaving: false,
            permissao: false,
            permissaoCadastrar: false,
            cantEdit: false,

            empresa: {
                idempresa: null,
                blindagem: null,
            },
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais'
            );
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais'
            );
        } else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-dados-cadastrais'
            );
        }

        this.permissaoCadastrar = this.permissao.create;
        this.cantEdit = !this.permissao.update;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'blindagem' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-blindagem-' + numberId;
        },
        save() {
            this.isLoading = true;

            let empresaTemp = Object.assign({}, this.empresa);

            this.isSaving = true;
            this.saveBlindagem(empresaTemp)
                .then((value) => {
                    if (value.status == 200) {
                        let msg = 'msg-edit-empresa';
                        this.msgs.push(new Message('success', msg, true));
                        this.$emit('isChanged', false);
                    } else {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar: ' + e);
                    this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
        saveBlindagem(empresaTemp) {
            if (this.isVenda) return this.service.saveBlindagemVendas(empresaTemp);
            else return this.service.saveBlindagemAgro(empresaTemp);
        },
        carregarDados() {
            this.isLoading = true;

            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.empresa.idempresa = value.content.idempresa;
                    this.empresa.blindagem = value.content.blindagem;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);
                });
        },
    },
    watch: {
        empresa: {
            deep: true,
            handler: function () {
                this.$emit('isChanged', true);
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
